/**
 * DataFast revenue attribution helpers.
 *
 * DataFast sets first-party cookies (`datafast_visitor_id`, `datafast_session_id`)
 * in the browser once its tracking script has loaded. To attribute Stripe
 * payments to a marketing channel/session, those cookie values must be sent
 * along with the Stripe Checkout Session creation request as metadata.
 *
 * Since Stripe Checkout sessions are created server-side via Supabase Edge
 * Functions (a different origin than listbright.ai), the cookies are not
 * forwarded automatically — we read them here on the client and pass them
 * explicitly in the request body.
 */

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

export interface DataFastAttribution {
  datafast_visitor_id?: string;
  datafast_session_id?: string;
}

/** Reads the DataFast attribution cookies for inclusion in checkout requests. */
export function getDataFastAttribution(): DataFastAttribution {
  return {
    datafast_visitor_id: readCookie('datafast_visitor_id'),
    datafast_session_id: readCookie('datafast_session_id'),
  };
}
